import axios from "axios";
import { API_URL } from "../config";

export const updateStudentCoins = async () => {
  try {
    const token = JSON.parse(localStorage.getItem("authToken"));
    if (!token) throw new Error("No auth token found");

    await axios.post(
      `${API_URL}/update-student-coins/`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token.access}`,
        },
      }
    );

    console.log("Coins updated successfully!");
  } catch (error) {
    console.error(
      "Failed to update coins:",
      error.response?.data || error.message
    );
  }
};

export const fetchProfile = async () => {
  const tokenString = localStorage.getItem("authToken");
 if (!tokenString) return null;

  const token = JSON.parse(tokenString);
  try {
    const res = await fetch(`${API_URL}/student/profile/`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token.access}`,
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      throw new Error("Failed to fetch profile");
    }

    return await res.json();
  } catch (error) {
    console.error("fetchProfile error:", error);
    return null;
  }
};
